import { Box, Stack, Button, Typography } from "@mui/material";
import React from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

const style = {
  height: 50,
  border: `1px solid #F0F0F0`,
  boxShadow: "none",
  borderRadius: 0,
  backgroundColor: "text.white",
  "&:hover": {
    backgroundColor: "text.white",
  },
};

const disabledStyle = {
  opacity: 0.5,
  backgroundColor: "#e9e9e9",
  cursor: "not-allowed !important",
};

const Counter = ({
  value,
  handleDecreaseQty,
  handleIncreaseQty,
  disbleCounters,
}) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      {/* Decrement Button */}
      <Button
        disableRipple
        variant="outlined"
        color="error"
        onClick={handleDecreaseQty}
        disabled={disbleCounters?.subtract}
        sx={{
          ...style,
          ...(disbleCounters?.subtract && disabledStyle),
        }}
      >
        <RemoveIcon htmlColor="black" />
      </Button>

      {/* Counter Display */}
      <Typography
        variant="h5"
        fontWeight={500}
        sx={{
          ...style,
          minWidth: 64,
          height: 48,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {value}
      </Typography>

      {/* Increment Button */}
      <Button
        disableRipple
        variant="outlined"
        color="primary"
        onClick={handleIncreaseQty}
        disabled={disbleCounters?.add}
        sx={{
          ...style,
          ...(disbleCounters?.add && disabledStyle),
        }}
      >
        <AddIcon htmlColor={"black"} />
      </Button>
    </Stack>
  );
};

export default Counter;
